import React from 'react';
import {FurnitureProductsConstant} from './FurnitureProductsConstant';
import AlternatingLayout from '../shared-components/AlternatingLayout';
import { ProductCard } from '../productCard/ProductCard.jsx';
import fp11 from "../../assets/furniture-products/FP-11.png";
import fp24 from "../../assets/furniture-products/FP-24.png";
import fp25 from "../../assets/furniture-products/FP-25.png";
import fp26 from "../../assets/furniture-products/FP-26.png";

const FurnitureProducts = () => {

    return (
        <div className="furniture-products">
           <AlternatingLayout
                productDescription={"Explore our exquisite range of furniture products designed to enhance comfort and style in any healthcare setting. From ergonomic chairs to durable tables, our furniture collection is crafted with high-quality materials to ensure longevity and ease of maintenance. Whether you're furnishing a waiting room, patient room, or office space, our furniture solutions combine functionality with aesthetic appeal to create a welcoming environment for patients and staff alike."}
                data={FurnitureProductsConstant.dataFurnitureProducts}
                landScapeImg={false}
            />
            <div class="helmet-showcase">
                         <ProductCard
                                        title="Hospital Furniture Products"
                                        img={fp11}
                                        landScapeImg={true}
                                      />
                                       <ProductCard
                                        title="Hospital Furniture Products"
                                        img={fp24}
                                        landScapeImg={true}
                                      />
                                       <ProductCard
                                        title="Hospital Furniture Products"
                                        img={fp25}
                                        landScapeImg={true}
                                      />
                                       <ProductCard
                                        title="Hospital Furniture Products"
                                        img={fp26}
                                        landScapeImg={true}
                                      />
                                      </div>
                                      
                                       <style>{`
                    .helmet-showcase{display:flex;justify-content: center;margin-top: 10px;}
                  `}</style>
        </div>
    );
};

export default FurnitureProducts;